import React from 'react';
import { Component } from './component';

export const Container: React.FC = () => {
  return <Component />;
};
